<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'files.list.title.shortLabel' | translate}}
                <app-tooltip text="{{'files.list.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="actions">
            <a mat-raised-button color="accent"
                *ngIf="paramLink && doesShowParamLink"
                [routerLink]="paramLink.route">
                <mat-icon aria-label="Settings">{{ paramLink.icon }}</mat-icon>
                {{ paramLink.title | translate }}
            </a>

            <button mat-raised-button color="accent" type="button" class="refresh-button"
                [disabled]="isLoading"
                (click)="onGetFiles()">
                {{'files.actions.refresh.shortLabel' | translate}}
                <mat-icon aria-label="Refresh">refresh</mat-icon>
            </button>
        </section>
        <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
        <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="tabSelected($event)"
                color="accent" animationDuration="0ms" *ngIf="filesLists && provider === 'bbc2020'">
            <mat-tab [label]="'files.form.provider.title.bbcTab.fullLabel' | translate">
                <app-files-table [files]="filesLists.sourceFiles" [source]="fileSource.provider"></app-files-table>
            </mat-tab>
            <mat-tab [label]="'files.form.simulation.bbcTab.fullLabel' | translate">
                <app-files-table [files]="filesLists.simulationFiles" [source]="fileSource.simulation"></app-files-table>
            </mat-tab>
            <mat-tab [label]="'files.form.uploadBizzDev.shortLabel' | translate" *ngIf="role === 'bizzdev' || role === 'backoffice'">
                <app-files-table [files]="filesLists.systemFiles" [source]="fileSource.import"></app-files-table>
            </mat-tab>
        </mat-tab-group>
        <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="tabSelected($event)"
                color="accent" animationDuration="0ms" *ngIf="filesLists && provider !== 'bbc2020'">
            <mat-tab [label]="'files.form.provider.title.default.shortLabel' | translate">
                <app-files-table [files]="filesLists.sourceFiles" [source]="fileSource.provider"></app-files-table>
            </mat-tab>
            <mat-tab [label]="'files.form.simulation.title.shortLabel' | translate">
                <app-files-table [files]="filesLists.simulationFiles" [source]="fileSource.simulation"></app-files-table>
            </mat-tab>
            <mat-tab [label]="'files.form.uploadBizzDev.shortLabel' | translate" *ngIf="role === 'bizzdev' || role === 'backoffice'">
                <app-files-table [files]="filesLists.systemFiles" [source]="fileSource.import"></app-files-table>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
